import type { TimelineNode } from "@/mocks/events";

const typeStyle: Record<
  TimelineNode["type"],
  { icon: string; dot: string; badge: string; label: string }
> = {
  origin: { icon: "ri-map-pin-2-line", dot: "bg-primary-500", badge: "text-primary-700 bg-primary-50", label: "首爆" },
  ferment: { icon: "ri-fire-line", dot: "bg-accent-500", badge: "text-accent-800 bg-accent-100", label: "发酵" },
  peak: { icon: "ri-line-chart-line", dot: "bg-primary-600", badge: "text-primary-700 bg-primary-100", label: "峰值" },
  spread: { icon: "ri-share-forward-line", dot: "bg-secondary-500", badge: "text-secondary-800 bg-secondary-50", label: "扩散" },
  response: { icon: "ri-chat-check-line", dot: "bg-foreground-500", badge: "text-foreground-700 bg-background-200", label: "回应" },
};

export default function Timeline({ nodes }: { nodes: TimelineNode[] }) {
  return (
    <ol className="relative">
      <span className="absolute left-[19px] top-3 bottom-3 w-px bg-background-300" aria-hidden="true" />
      {nodes.map((node, index) => {
        const style = typeStyle[node.type];
        return (
          <li key={`${node.time}-${index}`} className="relative flex gap-5 pb-7 last:pb-0">
            <span
              className={`relative z-10 w-10 h-10 shrink-0 rounded-xl flex items-center justify-center text-background-50 ${style.dot}`}
            >
              <i className={`${style.icon} text-lg`} />
            </span>
            <div className="flex-1 pt-1">
              <div className="flex flex-wrap items-center gap-3">
                <span className="font-label text-xs text-foreground-500">{node.time}</span>
                <span className={`px-2 py-0.5 rounded-md text-xs font-label ${style.badge}`}>
                  {style.label}
                </span>
              </div>
              <h3 className="mt-2 font-heading text-base md:text-lg font-bold text-foreground-950">
                {node.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{node.desc}</p>
            </div>
          </li>
        );
      })}
    </ol>
  );
}